import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import TagsInput from 'components/form/tagsinput'
import { SelectPickerField } from 'components/form/selectpicker'

export const InstagramOnly = ({
  input: { value, onChange, ...input },
  meta: { error, touched }
}) => (
  <div className={error && touched && 'has-error'}>
    <TagsInput
      inputProps={{
        placeholder: 'Enter hashtag e.g. #hashtag',
        className: 'react-tagsinput-input input-medium',
        ...input,
        onBlur: input.onBlur.bind(input, value)
      }}
      addOnBlur
      value={value}
      onChange={onChange}
    />
  </div>
)

InstagramOnly.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

const InstagramOnlyField = ({ name }) => (
  <div>
    <Field
      name={`${name}.value`}
      component={SelectPickerField}
      defaultValue='media'
    >
      <option value='media'>MEDIA</option>
      <option value='comment'>COMMENT</option>
    </Field>
    <Field name={`${name}.primary`} component='input' type='hidden' value />
  </div>
)

InstagramOnlyField.propTypes = {
  name: PropTypes.string
}

export default InstagramOnlyField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/instagram/only/index.js